import { useEffect } from 'react';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import { requestGlobalPushPermission } from '../utils/pushManager';

/**
 * On app start, if push is already granted and user is authenticated,
 * silently ensure FCM token is saved to Customer profile.
 * This covers users who granted push before the Customer.fcmToken feature existed.
 */
export function useSyncFcmToken() {
  const { isAuthenticated } = useCustomerAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;

    // Already granted — silently sync token to Customer
    requestGlobalPushPermission().catch(() => {});
  }, [isAuthenticated]);
}
